import { Injectable } from "@angular/core";
import { OperatingSystemService, PlatformName } from "@obg/ngx.core";
import { WindowRef } from "@obg/ngx.global";

import { AppDownloadConfigService } from "./app-download.config";

@Injectable({
	providedIn: "root",
})
export class AppDownloadService {
	readonly isIOS = this.operatingSystemService.getOperatingSystem() === PlatformName.IOS;
	readonly isAndroid = this.operatingSystemService.getOperatingSystem() === PlatformName.Android;

	constructor(
		private windowRef: WindowRef,
		private appDownloadConfig: AppDownloadConfigService,
		private operatingSystemService: OperatingSystemService
	) {}

	downloadApp() {
		if (this.isIOS) {
			this.downloadIOSApp();
		} else {
			this.downloadAndroidApp();
		}
	}

	private downloadIOSApp() {
		this.windowRef.native.open(this.appDownloadConfig.getAppStoreUrl(), "_blank");
	}

	private downloadAndroidApp() {
		this.windowRef.native.open(this.appDownloadConfig.getAndroidAppUrl(), "_blank");
	}
}
